import { useTranslation } from "react-i18next";

import bubbleWeb from "../../assets/images/menu/disneyWeb/bubble-xl.svg";
import Text from "../../components/ui/Text";
import Touchable from "../../components/ui/Touchable";
import useStore from "../../hooks/store/useStore";
import useEventTracking from "../../services/EventTracking/useEventTracking";
import cn from "../../utils/cn";
import { menuItemData, menuItemStyles } from "./constants";

export default function ClubAppMenuItem({
  className,
  delay,
}: {
  className?: string;
  delay: string;
}) {
  const { t } = useTranslation();

  const { setShowAppDownloadModel } = useStore((state) => state.webVersion);

  const mutation = useEventTracking();

  const handleMenuClick = () => {
    mutation.mutate({
      pageId: "Disney Menu",
      eventId: "WorldFamilyClub",
    });

    setShowAppDownloadModel(true);
  };

  const { image } = menuItemData["clubApp"];

  return (
    <div
      className={cn(
        "disney-menu-slide-in flex flex-col items-center justify-center bg-cover p-3",
        menuItemStyles.bubbleWidth,
        className,
      )}
      style={{ backgroundImage: `url(${bubbleWeb})`, animationDelay: delay }}
      onClick={handleMenuClick}
    >
      <Touchable className="flex flex-col items-center gap-2">
        <img src={image} alt="app icon" className="size-14 tablet-lg:size-20" />
        <Text lg className="w-[111px] text-center font-medium tablet-lg:w-40">
          {t("worldFamilyClub")}
        </Text>
      </Touchable>
    </div>
  );
}
